export default __webpack_public_path__ + "static-json/ne_110m_admin_0_countries_lakes-0cb59907700bc98ed3d050ed3fbbda16.json";